<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.transportation_method, 'Metoda transport')"
      :items="transportationMethods"
      item-title="name"
      name="transportation_method"
      item-value="id"
      v-model="selectedTransportationMethod"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
      :loading="loading"
      :disabled="loading"
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTravelStore } from '~/plugins/store/travel';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { TransportationMethod } from '~/types/Travel';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => TransportationMethod | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-travel-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const travelStore = useTravelStore();
    const translationStore = useTranslationStore();
    const selectedTransportationMethod = ref(modelValue.value ? modelValue.value : null);
    const transportationMethods = ref<TransportationMethod[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);
    const loading = ref(false);

    onMounted(async () => {
      loading.value = true;
      transportationMethods.value = await travelStore.getTransportationMethodList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;
      const isValid = !!selectedTransportationMethod.value;
      emit('validation-travel-status', { field: 'transportation_method', isValid });
      loading.value = false;

      // Listen for validate event
      window.addEventListener('validate-travel', (data) => {
        if (data.detail && data.detail === 'transportation_method') {
          if (!selectedTransportationMethod.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-travel-status', { field: 'transportation_method', isValid: true });
          }
        }
      });
    });

    watch(selectedTransportationMethod, (newMethod) => {
      if (initialSetupDone) {
        emit('update:modelValue', newMethod);
      }
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue) {
        selectedTransportationMethod.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-travel-status', { field: 'transportation_method', isValid });
    });

    return {
      selectedTransportationMethod,
      translationList,
      translation,
      transportationMethods,
      error,
      loading
    };
  },
});
</script>

<style scoped>
</style>